import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { dropShadowM } from '@xing-com/tokens';

const ActionsContainer = styled.div<{ $items: number }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  gap: ${(props) => (props.$items > 2 ? '32px' : '48px')};
`;

const ActionButton = styled(Button)<{
  $color: string;
  $size: 'small' | 'medium';
}>`
  box-shadow: ${dropShadowM};

  ${(props) =>
    props.$size === 'small'
      ? `height: 48px; width: 48px;`
      : `height: 60px; width: 60px;`};

  ::after {
    background-color: ${(props) => props.$color};
  }
`;

export { ActionButton, ActionsContainer };
